import { legacyViewpointDefaultState, reducers } from './reducers';
import { persistentReducedStream } from '@ardoq/rxbeach';

const viewpoints$ = persistentReducedStream(
  'viewpoints$',
  legacyViewpointDefaultState,
  reducers
);

export { viewpoints$ };
